import { ExtraOptinEvent } from "@/services/analytics/events/extra-optin-event";
import { AnalyticsDataLayerEvent, AnalyticsEventType } from "../models";
import { AdobeBaseEvent } from "./adobe-base-event";
import { Store } from "vuex";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import router from "@/router";
import { GroupCampaign, isGroupCampaign } from "@/models";

export class AdobeExtraOptinEvent extends AdobeBaseEvent {
    constructor(optinEvent: ExtraOptinEvent, store: Store<AppState>, services: ServicesContainer) {
        super(store, services);

        (this as AnalyticsDataLayerEvent).event = optinEvent.eventType;

        this.web.webPageDetails = {
            language: window.navigator.language ? window.navigator.language.toLowerCase() : 'not-set',
            name: 'rewards:extras',            
            pageType: 'rewards',
            siteRegion: store.state.ui.countryProfile.countryCode || '',
            siteSection: 'rewards',
            URL: window.location.origin + router.currentRoute.fullPath,
            pageViews: {
                value: 1,
              },
        };

        if (optinEvent.eventType === AnalyticsEventType.PageLoaded) {
            this.web.webPageDetails.pageViews = { value: 1};
        }

        if (optinEvent.eventType === AnalyticsEventType.ActivateOffer) {
            this.commerce.offer = {
                itemID: optinEvent.activatedCampaign!.id.toString(),
                offerActivated: { value: 1 },
                offerName: `rewardsExtra - ${optinEvent.activatedCampaign!.title}`,
                offerTitle: optinEvent.activatedCampaign!.title,
                offerType: 'rewardsExtra',
                offerSource: 'rewardsStore', 
                rewardStore: {
                    isActivated: true,
                    campaignType: optinEvent.isGroupCampaign ? 'GroupOptIn' : 'OptIn'
                } 
            };

            this.web.webInteraction = {
                linkClicks: { value: 1 },
                linkTitle: optinEvent.activatedCampaign!.title,
                linkType: 'rewardsExtra',
                name: 'ACTIVATE',
                type: 'other',
            };

            if (optinEvent.isGroupCampaign) {
                this.web.webInteraction.linkPosition = optinEvent.cardInGroupIndex !== undefined
                    ? optinEvent.cardInGroupIndex.toString().padStart(2, '0')
                    : undefined;
            }
        }
    }
}